import { Box, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { InfoOutlined } from '@mui/icons-material';
import { useIsMobile } from '@uplift/hooks';
import { Tooltip } from './tooltip.component';

export type LabelInfoTooltipProps = {
  label: string;
  tooltipTitle: NonNullable<React.ReactNode>;
  icon?: JSX.Element;
};

export const LabelInfoTooltip: React.VFC<LabelInfoTooltipProps> = ({ label, tooltipTitle, icon }) => {
  const { classes } = useStyles();
  const isMobile = useIsMobile('sm');
  const Icon = icon ?? <InfoOutlined fontSize="small" />;

  return (
    <Box display="flex" alignItems="center">
      {label}
      <Box ml={1}>
        <Tooltip
          title={tooltipTitle}
          placement={isMobile ? 'top' : 'right'}
          arrow
          classes={{ popper: classes.popper, tooltipPlacementTop: classes.tooltipPlacementTop }}
          // for tooltip to work on mobile - https://stackoverflow.com/questions/69030402/material-ui-tooltip-is-not-working-on-mobile
          enterTouchDelay={0}
          // arbitrary - gives enough time for user to read on mobile, and they can still click away to close
          leaveTouchDelay={10000}
        >
          <IconButton className={classes.iconButton} disableRipple size="small">
            {Icon}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

const useStyles = makeStyles()((theme) => ({
  popper: {
    zIndex: theme.zIndex.modal + 1,
  },
  iconButton: {
    cursor: 'default',
  },
  tooltipPlacementTop: {
    top: theme.spacing(2)
  }
}));
